import { Container, Mesh, Program, PlaneGeometryBuffer } from 'beam';
import BezierEasing from './helpers/BezierEasing';
import getPosition from './helpers/getPosition'
import bgVertexShader from './shaders/bg-vs.glsl'
import bgFragmentShader from './shaders/bg-fs.glsl'

const easing = BezierEasing( 0.775, 0.065, 0.345, 0.880 );

export default class GLBackground extends HTMLElement {

    constructor() {
        super();
        this.resize        = this.resize.bind(this);
        this.update        = this.update.bind(this);
        this._top = 0;
    }

    connectedCallback() {
        this.__isConnected__ = true;

        let node = this;
        let i=0;
        while (node.parentNode && i<100) { 
            if (node.parentNode.tagName == 'WEBGL-SCENE') {
                this.$glScene = node.parentNode;
                break;
            }
            node = node.parentNode;
            i++;
        }

        console.log('<gl-background> connectedCallback()')

        if (!this.$glScene) {
            console.warn('missing <gl-scene> parent node');
            return
        }
     
        requestAnimationFrame(()=>{
            this.init();
            window.addEventListener('resize', this.resize);
            document.addEventListener('resize', this.resize);
            this.resizeObserver = new ResizeObserver(this.resize);
            this.resizeObserver.observe(this);
            this.resizeObserver.observe(document.body);
            this.update();
        })
    }

    update() {
        if (!this.__isConnected__) {
            return;
        }
        requestAnimationFrame(()=>{
            this.update();
        });
        const r = 3//(window.innerHeight * 2) / Math.abs(this.$glScene._cameraZ)
        this.plane.scale[0] = window.innerWidth * 1 * r;
        this.plane.scale[1] = this._height * r ;
        this.plane.scale[2] = 1;
        this.plane.position[0] = 0
        this.plane.position[1] = (this.$glScene._scroll - this._top - (this._height - window.innerHeight)/2) * 3; 
        this.plane.position[2] = this.$glScene._cameraZ * -2//window.innerHeight * -2

        // this.$glScene.setDarkMask(this._top - this.$glScene._scroll , this._height)
    }

    init() {

        console.log('<gl-background> init()')

        this.renderer = this.$glScene.renderer;
        const plane = new Mesh();
        plane.geometry = new PlaneGeometryBuffer(this.renderer.gl, {
            width:   1, 
            height: 1,
        });
        plane.material = new Program(this.renderer.gl, {
            vertexShader:   bgVertexShader,
            fragmentShader: bgFragmentShader,
        });
        this.plane = plane;
        this.$glScene.addChild(plane);
        this.resize();
    }

    disconnectedCallback() {
        this.__isConnected__ = false;
        this.$glScene.setDarkMode(false);
        this.$glScene.removeChild(this.plane);
        document.removeEventListener('resize', this.resize);
        window.removeEventListener('resize', this.resize);
        this.resizeObserver.unobserve(this);
        this.resizeObserver.unobserve(document.body);
        // this.intersectionObserver.unobserve(this);
        // this.$glScene.setDarkMask(0,0)
    }

    resize() {
        console.log('<gl-background> resize()', this._top, this._height);
        this._top    = getPosition(this).top;
        this._height = this.clientHeight;
    }

}

customElements.define('gl-background', GLBackground);